<p>
  Um das Planungstool SPR+ Expert in vollem Umfang zu nutzen, benötigen Sie
  eine kostenpflichtige Lizenz. Diese können Sie hier online bestellen.
</p>

<p>
  Bitte beachten Sie, dass jede Bestellung individuell und manuell geprüft wird.
  Nach der erfolgreichen Überprüfung erfolgt die Zusendung der Zugangsdaten.
</p>

<p>
  Führen Sie folgende Schritte zur Lizenzbestellung durch:
</p>

<ul>
  <li>Adresse angeben</li>
  <li>Lizenz wählen</li>
  <li>AGB lesen und akzeptieren</li>
  <li>Bestellung kontrollieren und absenden</li>
</ul>

<div class="buttonRow">
  <button (click)="appController.next()">Weiter</button>
</div>
